<template>
    <div class="body"  v-if="dataList.length>0">
       <h1 class="package-title-ka"><p>请在激活有效期内领取，过期失效</p></h1>
        <van-row v-for="item in dataList" :key="item.id">
            <van-col :span="19">
                <div class="content">
                    <div class="congten-img">
                        <img :src="item.imgs" alt="">
                    </div>
                    <div class="title">
                        <div class="f-title">领取号码：{{item.tuiIccid}}</div>
                        <div class="f-title-s">激活：{{item.startTime}}</div>
                          <div class="f-title-s">过期：{{item.endTime}}</div>
                    </div>
                </div>
            </van-col>
            <van-col :span="5">
                <div class="exchange" v-if="item.state === 0" @click="exchange(item)">兑换</div>
                  <div class="y-exchanges" v-else-if="item.state === 5" @click="exchange(item)">过期已失效</div>
                <div class="y-exchange" v-else>{{item.stateName}}</div>
            </van-col>
        </van-row>
    </div>
    <div v-else class="body">
       <h1 class="package-title-ka"><p>请在激活有效期内领取，过期失效</p></h1>
        <div class="tips">---未查询到激活卡号，请先邀请好友领取流量卡激活---</div>
        <mt-button
           style="background: #26a2ff"
            class="tag-read"
            data-clipboard-action="copy"
            type="primary"
            size="large"
            @click.prevent="sureVerifiedHandler"
            >点击此处，即可分享好友领取</mt-button
          >
    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast,Dialog } from 'vant';
export default {
    data(){
        return{
            dataList:[]
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
            var params = {
                iccid:this.$store.state.iccid
            }
            wxRequest('/applyChangeSim/show/salePrice/tui',params, 'post').then(res => {
                if(res.data.code == 200){
                    this.dataList = res.data.data;
                 this.dataList.sort((a,b) => a.state - b.state);
                }else {
                    Toast.fail(res.data.message);
                }
            })
        },
        exchange(data){
            var params = {
                id:data.id
            }
            wxRequest('/applyChangeSim/show/salePrice/tui/apply',params, 'post').then(res => {
                if(res.data.code == 200){
                      Dialog.confirm({
              title: "兑换成功",
              message:
                "您已成功兑换余额，点击 确认 即可查询余额信息!",
            }).then((action) => {
              if (action == "confirm") {
                this.$router.replace("/user/balanceRecharge");
              }
            });
                    this.init()
                }else {
                    Toast.fail(res.data.message);
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
 .tips {
                color: #a0a0a0;
                text-align: center;
                line-height: 300px;
            }
    .body{
        .package-title-ka {
      width: 100;
      height: 46px;
      background: url("../../assets/img/topback.png") no-repeat;
      background-size: 100% 100%;
      padding:0 12px;
      font-size: 18px;
      font-weight: bold;
      color: #FFFFFF;
      display: flex;
      align-items: center;
    }
        .van-row{
            margin:13px;
            border-bottom:1px solid #FAFAFA;
            padding-bottom:16px;
            .content{
                display: flex;
                align-items: center;
               .congten-img{
                    width: 50px;
                    height:50px;
                    text-align: center;
                    background: #FFF2FF;
                    border-radius:100%;
                    line-height:50px;
                    margin-right: 10px;
                    img{
                        width:30px;
                        vertical-align: middle;
                    }
               } 
               .title{
                .f-title{
                    font-size:15px;
                    font-weight: 500;
                    margin-bottom:4px;
                }
                .f-title-s{
                    color: #999999;
                    font-size:12px;
                    margin-top:8px;
                }
               }
            }
            .van-col--5{
                padding-top: 12px;
            }
            .exchange{
                height:30px;
                width:66px;
                font-size: 14px;
                color:#FFF;
                line-height:30px;
                text-align: center;
                cursor: pointer;
                border-radius:15px;
                background: -webkit-linear-gradient(to right,#FEAC37,#FD7324); /* Safari 5.1-6.0 */
                background: -o-linear-gradient(to right,#FEAC37,#FD7324); /* Opera 11.1-12.0 */
                background: -moz-linear-gradient(to right,#FEAC37,#FD7324); /* Firefox 3.6-15 */
                background: linear-gradient(to right,#FEAC37,#FD7324); /* 标准语法 */
            }
            .y-exchange{
                height:30px;
                width:80px;
                font-size: 14px;
                color:#FFF;
                line-height:30px;
                text-align: center;
                border-radius:15px;
                background: #D8D8D8;
            }
            .y-exchanges{
                height:30px;
                width:80px;
                font-size: 14px;
                color:#FFF;
                line-height:30px;
                text-align: center;
                border-radius:15px;
                background: #ebafaf;
            }
        }
    }
</style>